import $ from 'jquery';

$('form[name="addReview"]').submit(function (e) {
    e.preventDefault();

    const isPolicyChecked = $(this).find('input#reviews-add-policy[type="checkbox"]').prop('checked');
    const $warningMessageElem = $(this).find('.reviews-add__warning');

    if (!isPolicyChecked) {
        $warningMessageElem.show();
        return false;
    }

    $warningMessageElem.hide();

    const {action: url} = this;
    const data = new FormData(this);

    $.post({
        url,
        data,
        processData: false,
        contentType: false,
        dataType: 'json'
    })
        .done(({status}) => {
            if (status === true) {
                $('.reviews-add__success').fadeIn();
            }
        });
});
